import SegmentTablev2 from "./SegmentTablev2";
export { OverallProgressStatus } from './ProgressStatus'

export default SegmentTablev2;
